import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivitiesListComponent } from './activities-list/activities-list.component';
import { ActivitiesLiteCheckOutComponent } from './activities-lite-check-out/activities-lite-check-out.component';
import { ActivitiesLiteOrderSummaryComponent } from './activities-lite-order-summary/activities-lite-order-summary.component';
import { ActivityCartComponent } from './activity-cart/activity-cart.component';
import { ActivitySessionSelectionComponent } from './activity-session-selection/activity-session-selection.component';
import { ActivityBookingConfirmationComponent } from './activity-booking-confirmation/activity-booking-confirmation.component';

const routes: Routes = [
    {
        path: '',
        component: ActivitiesListComponent
    },
    {
        path: 'list/:merchantId',
        component: ActivitiesListComponent
    },
    {
        path: 'slot-selection/:restaurantId/:merchantId',
        component: ActivitySessionSelectionComponent
    },
    {
        path: 'order-summary/:merchantId',
        component: ActivitiesLiteOrderSummaryComponent
    },
    {
        path: 'order-summary/edit/:restaurantId/:merchantId',
        component: ActivitiesLiteOrderSummaryComponent
    },
    {
        path: 'cart-summary/:merchantId',
        component: ActivityCartComponent
    },
    {
        path: 'confirmation/:merchantId/:token',
        component: ActivityBookingConfirmationComponent
    },
    {
        path: 'checkout/:merchantId',
        component: ActivitiesLiteCheckOutComponent
    },
    {
        path: 'list/:merchantId/:activityId',
        component: ActivitiesListComponent 
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ActivitiesLiteRoutingModule { }
